import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { hoistNonReactStatics } from '@wp-g2/utils';
import React from 'react';
import RouterContext from './RouterContext';
/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";

  var C = function (props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return /*#__PURE__*/React.createElement(RouterContext.Consumer, null, function (context) {
      return /*#__PURE__*/React.createElement(Component, Object.assign({}, remainingProps, context, {
        ref: wrappedComponentRef
      }));
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;
  return hoistNonReactStatics(C, Component);
}

export default withRouter;